import Env from './Env'
import RestResultType from './RestResultType'
import RestMethod from './RestMethod'

const URL_HEAD = Env.URL_HEAD
const POST_COMMON_HEADER = { 'Content-Type': 'application/json; charset=utf-8' }

export default {

  POST: {
    name: 'POST',
    url: URL_HEAD + 'post',
    header: POST_COMMON_HEADER,
    method: RestMethod.POST,
    resultType: RestResultType.JSON
  }
}



// WEBPACK FOOTER //
// ./src/scripts/consts/RestCfg.js